import Vue from 'vue';
import { mapState, mapActions } from 'vuex';
export default Vue.extend({
    data() {
        return {
            letters: [],
            query: '',
        };
    },
    created() {
        this.letters = this.getLetters();
        this.getBrands();
    },
    computed: {
        ...mapState('brandsModule', ['brands']),
        filteredBrands() {
            return this.brands.filter((brand) => brand.name
                ? brand.name.toUpperCase().startsWith(this.query.toUpperCase())
                : false);
        },
    },
    methods: {
        ...mapActions('brandsModule', ['getBrands']),
        getLetters() {
            const firstLetterIndex = 97;
            const lastLetterIndex = 122;
            const letters = [
                ...new Array(lastLetterIndex - firstLetterIndex + 1),
            ].map((el, i) => {
                return String.fromCharCode(firstLetterIndex + i).toUpperCase();
            });
            Array.from(Array(10).keys()).map((i) => {
                letters.push(i.toString());
            });
            return letters;
        },
        getLetterBrands(letter) {
            return this.filteredBrands.filter((brand) => brand.name ? brand.name.startsWith(letter) : false);
        },
        addLetterToQuery(letter) {
            this.query = '';
            this.query = this.query + letter;
        },
        reduceQuery() {
            this.query = this.query.slice(0, -1);
        },
        resetQuery() {
            this.query = '';
        },
    },
});
